import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  Typography,
  TextField,
  MenuItem,
  Box,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import AuthContext from "../Context/AuthProvider";
import {
  addPrescription,
  updatePrescription,
  getPrescription,
  removePrescription,
  viewPrescriptionById,
} from "../API/PrescriptionApi";
import { getServiceDetails } from "../API/LinkedServicesApi";
import HeaderValueDisplay from "../common/HeaderValueDisplay";
import { formatAge } from "../Utility/Utility";
import { convertUTCToTimeZoneDateTimeString } from "../Utility/DateTimeUtility";
import MenuBar from "../common/MenuBar";
import {
  PrescriptionTypes,
} from "../Utility/Constants";
import { getFrozenShoulderDataJson } from "./FrozenShoulderDataStructure";
import { getPhysiotherapyPrescriptionDataJson } from "./PhysiotherapyPrescriptionDataStructure";
import { getGeneralPrescriptionDataJson } from "./GeneralPrescriptionDataStruture1";
import { useSnackbar } from "../Utility/UserMessageContext";
import { showLoadingImage } from "../Utility/Utility";
import FrozenShoulderPrescriptionDisplay from "./FrozenShoulderPrescriptionDisplay";
import PhysiotherapyPrescriptionDisplay from "./PhysiotherapyprescriptionDisplay";
import GeneralPrescriptionDisplay from "./GeneralPrescriptionDisplay";
import { clearFormDataFromLocal, getFormData, getFormDataFromLocal, saveFormDataToLocal } from "../Utility/FormDataTempStorage";
import { getPathLabTestDataJson } from "./PathologyReportDataStructure";
import LaboratoryTestReportDisplay from "./LaboratoryTestReportDisplay";
import { removeRefund } from "../API/BillingApi";
import { getDentalPrescriptionDataJson } from "./DentalDataStructure";
import DentalPrescriptionDisplay from "./DentalPrescriptionDisplay";

function BaseMedicalRecordForm({
  serviceId,
  uniqueId,
  recordId,
  onSaveRecord,
  onRemoveRecord,
  onNewRecordSaved,
  formType,
}) {
    console.log("BaseMedicalRecordForm formType:", formType);  // ← ADD THIS
  console.log("PathologyLabReport constant:", PrescriptionTypes.PathologyLabReport);
  console.log("Match?", formType === PrescriptionTypes.PathologyLabReport);
  const { auth } = useContext(AuthContext);
  const { showSnackbar } = useSnackbar();
  const [currentService, setCurrentService] = useState();
  const [isSaving, setIsSaving] = useState(false);
  const [medicalRecordStatus, setMedicalRecordStatus] = useState("Draft");
  const [readOnly, setReadOnly] = useState(false);
  const [currentRecordId, setCurrentRecordId] =
    useState(recordId);

  const getFormDataTemplateByType = (type) => {
    switch (type) {
      case PrescriptionTypes.FrozenShoulder:
        return getFrozenShoulderDataJson();
      case PrescriptionTypes.PhysiotherapyPrescription:
        return getPhysiotherapyPrescriptionDataJson();
      case PrescriptionTypes.GeneralPrescription:
        return getGeneralPrescriptionDataJson();
      case PrescriptionTypes.PathologyLabReport:
        return getPathLabTestDataJson();
        case PrescriptionTypes.DentalPrescription:
          return getDentalPrescriptionDataJson();
      default:
        return {};
    }
  };

  const [formData, setFormData] = useState(
    getFormDataTemplateByType(formType)
  );

  useEffect(() => {
    const loadPrescription = async () => {
      const unsavedData = getFormDataFromLocal(uniqueId);
        if (unsavedData) {
              setFormData(unsavedData);
        } else if (auth && currentRecordId) {
        try {
          setIsSaving(true);
          const result = await getPrescription(auth, currentRecordId);
          if (result?.isSuccess) {
            const p = result.data;
            const details = JSON.parse(p?.detailedPrescription || "{}");
            setMedicalRecordStatus(p?.status);
            onNewRecordSaved && onNewRecordSaved(uniqueId, p?.id, p?.displayId);
            setFormData(details);
            if (p?.status === "Final") setReadOnly(true);
          }
        } catch (error) {
          showSnackbar("Error loading prescription: " + error.message, "error");
        }
        finally {
          setIsSaving(false);
        }
      }
    };
    loadPrescription();
  }, [currentRecordId, uniqueId]);

  useEffect(() => {
    const loadService = async () => {
      if (auth && serviceId) {
        setIsSaving(true);
        try {
          const result = await getServiceDetails(auth, serviceId);
          if (result?.isSuccess) {
            setCurrentService(result?.data);
          } else {
            showSnackbar(
              result?.data?.message ||
                JSON.stringify(result?.data) ||
                "An error occurred",
              "error",
            );
          }
        } catch (error) {
          showSnackbar(
            "Error loading service details: " + error.message,
            "error",
          );
        } finally {
          setIsSaving(false);
        }
      }
    };
    loadService();
    // else {
    //   loadService();
    // }
  }, [serviceId]);

  let finalserviceName = currentService?.serviceCode + " " + currentService?.serviceName;

  const onRemoveRecordClick = async () => {
    if (auth && currentRecordId) {
      try {
        const result = await removePrescription(auth, currentRecordId);
        if (result?.isSuccess) {
          onRemoveRecord(serviceId, currentRecordId);
          showSnackbar("Record removed successfully", "success");
        } else {
          showSnackbar(
            result?.data || "Failed to remove record",
            "error",
          );
        }
      } catch (error) {
        showSnackbar("Error removing record: " + error.message, "error");
      }
    }
  };

 const savePrescription = async (statusToSave) => {
    setIsSaving(true); // Add this line

   var result = {};
      if (!currentRecordId) {
        result = await addPrescription(
          auth,
          formData,
          currentService?.id,
           formType, // ← uses formType directly so it works for all prescription types
          //  getPrescriptionType(formType),
          statusToSave
        );
        if(result?.isSuccess){
          setCurrentRecordId(result?.data);
        }
      } else {
        result = await updatePrescription(
          auth,
          formData,
          currentRecordId,
          statusToSave
        );
      }
      if (result.isSuccess) {
        clearFormDataFromLocal(uniqueId);
        setMedicalRecordStatus(statusToSave);
        onSaveRecord(serviceId, currentRecordId, statusToSave);
        showSnackbar(
          "The record has been saved successfully.",
          "success"
        );
      } else {
        showSnackbar(result?.data, "error");
      }
      setIsSaving(false);
 };

 const handleRecordDownload = async () => {
      try {
        if (auth != null && currentRecordId != null) {
          await viewPrescriptionById(auth, currentRecordId);
        }
      } catch (error) {
        showSnackbar("Error viewing prescription: " + error.message, "error");
      }
 }

  return (
    <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
      {isSaving && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(216, 214, 214, 0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1301,
          }}
        >
          {showLoadingImage()}
        </div>
      )}
      <Grid2 container size={12} spacing={2}>
        <Grid2 size={12}>
          <MenuBar
            showSave={medicalRecordStatus !== "Final"}
            onSave={() => savePrescription("Draft")}
            showFinalize={medicalRecordStatus !== "Final"}
            onFinalize={() => savePrescription("Final")}
            showDelete={medicalRecordStatus === "Draft"}
            showDownload={medicalRecordStatus === "Final"}
            onDownload={handleRecordDownload}
            onDelete={onRemoveRecordClick}
            disabled={isSaving}
          />
        </Grid2>

        <Grid2 size={9}>
          <Card
            className="outerCard"
            variant="outlined"
            sx={{
              width: "100%",
              overflow: "auto",
              ml: "10px",
              padding: "10px",
            }}
          >
            <Grid2
              container
              size={12}
              spacing={2}
              sx={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}
            >
              {/* Patient Information Card */}
              <Grid2 size={12}>
                <Card
                  sx={{
                    padding: { xs: 2, md: 3 },
                    // pointerEvents: showLoading ? "none" : "auto",
                    // opacity: showLoading ? 0.6 : 1,

                    color: "text.primary",
                    mb: 2,
                  }}
                  variant="outlined"
                >
                  <Grid2 container size={12} spacing={2}>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <HeaderValueDisplay
                        header="Patient Name"
                        value={
                          currentService?.patientPrefix +
                          " " +
                          currentService?.patientFirstName +
                          " " +
                          currentService?.patientLastName
                        }
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <HeaderValueDisplay
                        header="Age and Gender"
                        value={
                          formatAge(currentService?.patientAgeInYears) +
                          " and " +
                          currentService?.patientGender
                        }
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <HeaderValueDisplay
                        header="MRN"
                        value={currentService?.patientMRN}
                      />
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <HeaderValueDisplay
                        header="Visit Id"
                        value={currentService?.visitDisplayId}
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <HeaderValueDisplay
                        header="Visit Type"
                        value={currentService?.visitType}
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <HeaderValueDisplay
                        header="Visit Date Time"
                        value={convertUTCToTimeZoneDateTimeString(
                          new Date().toISOString(),
                          Intl.DateTimeFormat().resolvedOptions().timeZone,
                        )}
                      />
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <HeaderValueDisplay
                        header="Service Id"
                        value={currentService?.displayId}
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <HeaderValueDisplay
                        header="Service Name"
                        value={finalserviceName}
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <HeaderValueDisplay
                        header="Service Date Time"
                        value={convertUTCToTimeZoneDateTimeString(
                          new Date().toISOString(),
                          Intl.DateTimeFormat().resolvedOptions().timeZone,
                        )}
                      />
                    </Grid2>
                  </Grid2>
                </Card>
              </Grid2>

              {/* ── Form-type specific display ── */}
              <>
                {formType === PrescriptionTypes.FrozenShoulder && (
                  <FrozenShoulderPrescriptionDisplay
                    uniqueId={uniqueId}
                    formData={formData}
                    readOnly={readOnly}
                    setFormData={setFormData}
                  />
                )}

                {/* ── NEW: Physiotherapy block ── */}
                {formType === PrescriptionTypes.PhysiotherapyPrescription && (
                  <PhysiotherapyPrescriptionDisplay
                    uniqueId={uniqueId}
                    formData={formData}
                    readOnly={readOnly}
                    setFormData={setFormData}
                  />
                )}

                {/* ── NEW: General Prescription block ── */}
                {formType === PrescriptionTypes.GeneralPrescription && (
                   console.log("Rendering GeneralPrescriptionDisplay") ||
                  <GeneralPrescriptionDisplay
                    uniqueId={uniqueId}
                    formData={formData}
                    readOnly={readOnly}
                    setFormData={setFormData}
                  />
                )}

                {/* ── NEW: Lab Test Report block ── */}
                {formType === PrescriptionTypes.PathologyLabReport && (
                  console.log("Rendering LaboratoryTestReportDisplay, formData keys:", Object.keys(formData)) ||
                  <LaboratoryTestReportDisplay
                    uniqueId={uniqueId}
                    formData={formData}
                    readOnly={readOnly}
                    setFormData={setFormData}
                  />
                )}
                {formType === PrescriptionTypes.DentalPrescription && (
  <DentalPrescriptionDisplay
    uniqueId={uniqueId}
    formData={formData}
    readOnly={readOnly}
    setFormData={setFormData}
  />
)}
              </>
            </Grid2>
          </Card>
        </Grid2>
      </Grid2>
    </Box>
  );
}

export default BaseMedicalRecordForm;